/* eslint-disable react/no-array-index-key */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Type, ButtonSecondary } from '@spotify-internal/encore-creator-web';
import styles from './index.module.css';
import { PreviewPanePodcast } from '../../../types';
import { FormattedMessage } from 'react-intl';

interface Props {
  location: {};
  history: {
    push: ({}) => void;
  };
  unsetSubmitFeedStatus: () => void;
  loadMe: () => void;
  rssFeed: PreviewPanePodcast | null;
  existingPodcast: boolean;
}

export class Finished extends PureComponent<Props> {
  static propTypes = {
    location: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    unsetSubmitFeedStatus: PropTypes.func.isRequired,
    loadMe: PropTypes.func.isRequired,
    existingPodcast: PropTypes.bool.isRequired,
    rssFeed: PropTypes.shape({
      isExistingShow: PropTypes.bool,
    }),
  };

  static defaultProps = {
    rssFeed: {},
  };

  goToCatalog = () => {
    this.props.loadMe();
    this.props.unsetSubmitFeedStatus();
    const { history, location } = this.props;
    history.push({
      ...location,
      pathname: `/catalog`,
      search: null,
    });
  };

  renderNewPodcastMessage = () => (
    <div className={styles.finished_cta}>
      <Type as="h1" className={styles.finished_heading} variant={Type.display2}>
        <FormattedMessage
          id="add-podcast.finished-new-title"
          defaultMessage="Nice! We got your podcast."
        />
      </Type>
      <Type as="p" className={styles.finished_text} variant={Type.heading4}>
        <FormattedMessage
          id="add-podcast.finished-new-description"
          defaultMessage="It’ll take a few hours for your podcast to show up on Spotify."
        />
      </Type>
      <ButtonSecondary
        data-testid="finished-button"
        className="finished-button"
        onClick={this.goToCatalog}
        theme={ButtonSecondary.darkTheme}
      >
        <FormattedMessage
          id="add-podcast.finished-existing-button"
          description="Button text after successfully adding a new podcast"
          defaultMessage="Track Podcast"
        />
      </ButtonSecondary>
    </div>
  );

  renderExistingPodcastMessage = () => (
    <div className={styles.finished_cta}>
      <Type as="h1" className={styles.finished_heading} variant={Type.display2}>
        <FormattedMessage id="add-podcast.finished-existing-title" defaultMessage="You’re in!" />
      </Type>
      <Type as="p" className={styles.finished_text} variant={Type.heading4}>
        <FormattedMessage
          id="add-podcast.finished-existing-description"
          defaultMessage="Now that you’ve added your podcast to Spotify, you can see powerful stats, updated daily."
        />
      </Type>
      <ButtonSecondary
        data-testid="finished-button"
        className="finished-button"
        onClick={this.goToCatalog}
        theme={ButtonSecondary.darkTheme}
      >
        <FormattedMessage
          id="add-podcast.finished-existing-button"
          description="Button text after successfully gaining access to an existing podcast"
          defaultMessage="See stats"
        />
      </ButtonSecondary>
    </div>
  );

  render() {
    return (
      <section>
        {this.props.existingPodcast
          ? this.renderExistingPodcastMessage()
          : this.renderNewPodcastMessage()}
      </section>
    );
  }
}
